module.exports = __webpack_public_path__ + "img/caramel_frappe.ce2f41eb.jpg";